import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GuardService } from './services/guard.service';

const routes: Routes = [
  {
    path: '',
    canActivate: [GuardService],
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'events',
    canActivate: [GuardService],
    loadChildren: () =>
      import('./pages/events/events.module').then((m) => m.EventsModule),
  },
  {
    path: 'users',
    canActivate: [GuardService],
    loadChildren: () =>
      import('./pages/users/users.module').then((m) => m.UsersModule),
  },
  {
    path: 'catalogs',
    canActivate: [GuardService],
    loadChildren: () =>
      import('./pages/catalogs/catalogs.module').then((m) => m.CatalogsModule),
  },
  {
    path: 'libraries',
    canActivate: [GuardService],
    loadChildren: () =>
      import('./pages/digital-libraries/digital-libraries.module').then((m) => m.DigitalLibrariesModule),
  },
  {
    path: 'application',
    canActivate: [GuardService],
    loadChildren: () =>
      import('./pages/application/application.module').then((m) => m.ApplicationModule),
  },
  {
    path: 'communications',
    canActivate: [GuardService],
    loadChildren: () =>
      import('./pages/communications/communications.module').then((m) => m.CommunicationsModule),
  },
  {
    path: 'settings',
    canActivate: [GuardService],
    loadChildren: () =>
      import('./pages/settings/settings.module').then((m) => m.SettingsModule),
  },
  {
    path: 'file',
    canActivate: [GuardService],
    loadChildren: () =>
      import('./pages/digital-file/digital-file.module').then((m) => m.DigitalFileModule),
  },
  {
    path: 'perfil',
    canActivate: [GuardService],
    loadChildren: () =>
      import('./pages/perfil/perfil.module').then((m) => m.PerfilModule),
  },
  {
    path: 'calendar',
    canActivate: [GuardService],
    loadChildren: () =>
      import('./pages/calendar/calendar.module').then((m) => m.CalendarModule),
  },
  {
    path: 'not-found',
    canActivate: [GuardService],
    loadChildren: () =>
      import('./pages/not-found/not-found.module').then((m) => m.NotFoundModule),
  },
  {
    path: 'notifications',
    canActivate: [GuardService],
    loadChildren: () =>
      import('./pages/notifications/notifications.module').then((m) => m.NotificationsModule),
  },
  {
    path: 'templates',
    canActivate: [GuardService],
    loadChildren: () =>
      import('./pages/templates/templates.module').then((m) => m.TemplatesModule),
  },
  {
    path: '**',
    redirectTo: '/not-found',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled'
  }),],
  exports: [RouterModule],
})
export class AppRoutingModule { }
